import { render, staticRenderFns } from "./ProductIntroMobile.vue?vue&type=template&id=6e4189fa&scoped=true"
import script from "./ProductIntroMobile.vue?vue&type=script&lang=js"
export * from "./ProductIntroMobile.vue?vue&type=script&lang=js"
import style0 from "./ProductIntroMobile.vue?vue&type=style&index=0&id=6e4189fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4189fa",
  null
  
)

export default component.exports